export default "__VITE_ASSET__c8df6068__"